export default {
    type: 'blog-post-modules',
    aliases: {
        camel: 'blogPostModules',
        singular: 'Blog post module',
        plural: 'Blog post modules',
        lowerSingular: 'blog post module',
        lowerPlural: 'blog post modules',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
